<template>
    <section class="order-list-details">
        <div class="order-list-details-bloc">
            <header>
                <table class="table table-header">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t("orders.tableOrder.element") }}</th>
                            <th scope="col">{{ $t("orders.tableOrder.description") }}</th>
                            <th scope="col">{{ $t("orders.tableOrder.quantity") }}</th>
                            <th scope="col">x</th>
                            <th scope="col">{{ $t("orders.tableOrder.plano") }}</th>
                            <th scope="col">{{ $t("orders.tableOrder.unitPrice") }}</th>
                            <th scope="col">{{ $t("orders.tableOrder.totalPrice") }}</th>
                        </tr>
                    </thead>
                </table>
            </header>
            <div class="basetsList"><orderBasketDetails v-for="basket in order.baskets" :basket="basket" :key="basket.id"></orderBasketDetails></div>
            <div class="total-price" v-if="order.currency">
                <div class="total-price-subTotal">
                    <span class="label">{{ $t("orders.tableOrder.labelSubTotal") }} :</span>
                    <span class="price bold">{{
                        displayRealPrice(order.finalPrice, order.priceShown) | CurrencyCustomPipe("en-US", order.currency.shortName)
                    }}</span>
                </div>

                <div class="total-price-subTotal" v-if="order.shippingCost != null">
                    <span class="label"> {{ $t("orders.tableOrder.labelShippingCost") }} : </span>
                    <span class="price bold">
                        <div v-if="order.isShippingCostBtnAvailable && order.shippingCost != null" class="bloc-btn-modify">
                            <button class="btn btn-modify" @click="modifyShippingCost();">{{ $t("orders.btnOrders.btnModify") }}</button>
                        </div>
                        {{ displayRealPrice(order.shippingCost, order.priceShown) | CurrencyCustomPipe("en-US", order.currency.shortName) }} ({{
                            order.orderShippingMethod.name
                        }})</span
                    >
                </div>
                <div
                    class="total-price-shippingCost rel"
                    v-if="
                        (order.isShippingCostBtnAvailable && order.shippingCost == null) || (isModifyShippingCost && order.isShippingCostBtnAvailable)
                    "
                >
                    <loader :loading="loading"></loader>
                    <div class="shipping-input-bloc">
                        <span class="label">{{ $t("orders.tableOrder.labelShippingCost") }} :</span>
                        <span class="shipping-input"> <input type="number" min="0" step="any" v-model="shipping.shippingCost" /> </span>
                    </div>

                    <div class="shipping-input-bloc">
                        <span class="label">{{ $t("orders.tableOrder.labelShippingMethod") }} :</span>
                        <span class="shipping-input">
                            <select class="" v-model="shipping.orderShippingMethod.id">
                                <option :value="null">-- {{ $t("orders.tableOrder.labelShippingMethod") }} --</option>
                                <option v-for="shippingMethod in shippingMethods" :value="shippingMethod.id" :key="shippingMethod.id">
                                    {{ shippingMethod.name }}
                                </option>
                            </select>
                        </span>
                    </div>
                    <button class="btn validateShipping mt-10" @click="validateShipping();">{{ $t("orders.tableOrder.addShippingInfo") }}</button>
                </div>

                <div class="total-price-Total">
                    <span class="label">TOTAL :</span>
                    <span class="price bold">{{
                        displayRealPrice(order.totalSum, order.priceShown) | CurrencyCustomPipe("en-US", order.currency.shortName)
                    }}</span>
                    <button class="btn validateFinalprice" v-if="clientHasRights && order.isTotalCostBtnAvailable" @click="validatePrice();">
                        {{ $t("orders.tableOrder.validateTotalCostButton") }}
                    </button>
                </div>
            </div>

            <div class="bloc-shop-order" v-if="diamHasRights && order.isShippingOrderBtnAvailable">
                <button class="btn btn-shipOrder" @click.prevent="openModalShipOrder('editShipOrder');">Ship order</button>
                <ModalShipOrder :action="dataAction" id="ShipOrder"></ModalShipOrder>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import orderBasketDetails from "./orderBasketDetails";
import loader from "../../loader/loader";
import ModalShipOrder from "../modal/ModalShipOrder";
import cacheService from "@/services/cache";

export default {
    name: "OrderListDetails",
    data() {
        return {
            dataAction: "",
            loading: false,
            isModifyShippingCost: false,
            shipping: {
                shippingCost: 0,
                orderShippingMethod: {
                    id: null
                },
                languageCode: cacheService.getUserLang()
            }
        };
    },
    components: {
        orderBasketDetails,
        loader,
        ModalShipOrder
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder",
            shippingMethods: "details/shippingMethods"
        }),
        diamHasRights() {
            return this.hasDiamAccess("orders_manager", ...this.AccessUser.CONTRIBUTE);
        },
        clientHasRights() {
            return this.hasClientAccess("orders_manager", ...this.AccessUser.CONTRIBUTE);
        }
    },
    methods: {
        ...mapActions("order", {
            editShippingInfos: "details/editShippingInfos",
            validateFinalPrice: "details/validateFinalPrice"
        }),
        initShipping() {
            this.shipping = {
                shippingCost: this.order.shippingCost ? this.order.shippingCost : 0,
                orderShippingMethod: {
                    id: this.order.orderShippingMethod.id ? this.order.orderShippingMethod.id : null
                },
                languageCode: cacheService.getUserLang()
            };
        },
        modifyShippingCost() {
            this.isModifyShippingCost = true;
            this.initShipping();
        },
        openModalShipOrder(action) {
            this.dataAction = {
                action: action,
                data: this.order
            };
            this.$root.$emit("bv::show::modal", "ModalShipOrder");
        },
        async validatePrice() {
            if (this.order.isAddressBtnAvailable && !this.order.deliveryAddress) {
                this.dialogError(this.$t("orders.tableOrder.errorDeliveryAddress"));
                return;
            }
            try {
                this.loading = true;
                await this.validateFinalPrice();
                this.dialogSuccess(this.$t("orders.tableOrder.validateTotalCostSuccess"));
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        },
        async validateShipping() {
            if (this.shipping.shippingCost <= 0) {
                this.dialogError(this.$t("orders.tableOrder.errorShippingCost"));
                return;
            }
            if (this.shipping.orderShippingMethod.id == null) {
                this.dialogError(this.$t("orders.tableOrder.errorShippingMethod"));
                return;
            }
            this.loading = true;
            try {
                await this.editShippingInfos(this.shipping);
                this.dialogSuccess(this.$t("orders.tableOrder.shippingInfoSuccess"));
                this.isModifyShippingCost = false;
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../../assets/css/themes";

.order-list-details {
    &-bloc {
        border-bottom: 1px solid #ccc;
        padding-bottom: 20px;
    }
    & .bloc-shop-order {
        margin-top: 20px;
        text-align: right;
        padding: 0 20px;
        .btn-shipOrder {
            background-color: $color2;
            border-color: $color2;
        }
    }
    & .total-price {
        padding: 0 20px;
        @extend %primary-text;
        &-subTotal {
            margin: 5px 0px;
            text-align: right;
            .bloc-btn-modify {
                position: relative;
                display: inline-block;
                margin-left: 20px;
                top: 0;
            }
            & .price {
                width: 300px;
                text-align: right;
            }
        }
        &-Total {
            margin-top: 10px;
            text-align: right;
            .label {
                text-transform: uppercase;
                font-size: 20px;
            }
            & .price {
                font-family: Oswald;
                color: $color4;
                font-size: 21px;
                width: 300px;
                text-align: right;
            }
            .validateFinalprice {
                margin-top: 20px;
                background-color: $color2;
                border: none;
            }
        }
        span {
            display: inline-block;
        }
        & .label {
            width: calc(100% - 305px);
            font-size: 13px;
            font-weight: bold;
            font-family: "oswald-regular", sans-serif;
        }
        &-shippingCost {
            margin: 10px 0;
            text-align: right;
            & .shipping-input {
                width: 300px;
            }

            .shipping-input-bloc {
                margin: 10px 0px;
                input,
                select {
                    width: 150px;
                    padding: 5px;
                    @media only screen and (max-width: 767px) {
                        width: 140px;
                    }
                }
                select {
                    border: none;
                    display: inline-block;
                    border-radius: 1px;
                    padding: 5px 10px;
                    height: 35px;
                }
            }
        }
        .validateShipping {
            background-color: $color2;
            border-color: $color2;
        }
    }
    margin-bottom: 30px;
    header {
        color: #fff;
        background-color: $color4;
        text-transform: uppercase;
        padding: 0 20px;
        & .table-header {
            text-align: left;
            thead {
                tr {
                    th {
                        padding-left: 0;
                        padding-right: 0;
                        border: none;
                        &:last-child {
                            text-align: right;
                        }
                        &:nth-child(1) {
                            width: 15%;
                        }
                        &:nth-child(2) {
                            width: 35%;
                        }
                        &:nth-child(3) {
                            width: 10%;
                            text-align: center;
                        }
                        &:nth-child(4) {
                            width: 10px;
                            font-size: 12px;
                            text-transform: none;
                        }
                        &:nth-child(5) {
                            width: 10%;
                            text-align: center;
                        }
                        &:nth-child(6) {
                            width: 15%;
                        }
                        &:nth-child(7) {
                            width: 15%;
                        }
                    }
                }
            }
        }
    }
    .basetsList {
        padding: 0 20px;
    }
}
</style>



// WEBPACK FOOTER //
// OrderListDetails.vue?2d11b796